
import React, { useState } from 'react';


// Create a Profile component with an editable trainer bio
const Profile = () => {
  const [isEditing, setIsEditing] = useState(false);
  const [profileData, setProfileData] = useState({
    name: 'Alex Johnson',
    title: 'Certified Personal Trainer',
    specialties: ['Strength Training', 'Weight Loss', 'Bodybuilding'],
    bio: 'Passionate fitness professional with 8+ years of experience helping clients achieve their fitness goals. Specialized in strength training and nutrition planning. I believe in creating sustainable fitness habits that fit into your lifestyle.',
    email: 'alex.johnson@example.com',
    phone: '(555) 123-4567',
    location: 'San Francisco, CA',
    certifications: ['NASM Certified Personal Trainer', 'ACE Fitness Nutrition Specialist', 'ISSA Strength and Conditioning']
  });
  
  const [tempData, setTempData] = useState({...profileData});

  const handleEditToggle = () => {
    if (isEditing) {
      // Save changes
      setProfileData({...tempData});
    } else {
      // Start editing - create a temporary copy
      setTempData({...profileData});
    }
    setIsEditing(!isEditing);
  };

  const handleChange = (field, value) => {
    setTempData({...tempData, [field]: value});
  };

  const handleSpecialtiesChange = (index, value) => {
    const newSpecialties = [...tempData.specialties];
    newSpecialties[index] = value;
    setTempData({...tempData, specialties: newSpecialties});
  };

  const handleAddSpecialty = () => {
    setTempData({...tempData, specialties: [...tempData.specialties, '']});
  };

  const handleRemoveSpecialty = (index) => {
    const newSpecialties = tempData.specialties.filter((_, i) => i !== index);
    setTempData({...tempData, specialties: newSpecialties});
  };

  const handleCertificationChange = (index, value) => {
    const newCertifications = [...tempData.certifications];
    newCertifications[index] = value;
    setTempData({...tempData, certifications: newCertifications});
  };

  const handleAddCertification = () => {
    setTempData({...tempData, certifications: [...tempData.certifications, '']});
  };

  const handleRemoveCertification = (index) => {
    const newCertifications = tempData.certifications.filter((_, i) => i !== index);
    setTempData({...tempData, certifications: newCertifications});
  };

  return (

      <div className="profile-container fogged-card">
        <div className="profile-header">
          <div className="profile-image-container fogged-card">
            <div className="profile-image">
              {profileData.name.charAt(0)}
            </div>
            {isEditing && (
              <button className="change-photo-btn">Change Photo</button>
            )}
          </div>

          <div className="profile-info">
            {isEditing ? (
              <>
                <input 
                  type="text" 
                  value={tempData.name} 
                  onChange={(e) => handleChange('name', e.target.value)}
                  className="profile-name-input"
                  placeholder="Your Name"
                />
                <input 
                  type="text" 
                  value={tempData.title} 
                  onChange={(e) => handleChange('title', e.target.value)}
                  className="profile-title-input"
                  placeholder="Professional Title"
                />
              </>
            ) : (
              <>
                <h2 className="profile-name">{profileData.name}</h2>
                <p className="profile-title">{profileData.title}</p>
              </>
            )}
          </div>
          
          <button className="edit-profile-btn" onClick={handleEditToggle}>
            {isEditing ? 'Save Profile' : 'Edit Profile'}
          </button>
        </div>

        <div className="profile-section">
          <h3>Bio</h3>
          {isEditing ? (
            <textarea 
              value={tempData.bio}
              onChange={(e) => handleChange('bio', e.target.value)}
              className="bio-textarea"
              placeholder="Write a professional bio here..."
              rows={5}
            />
          ) : (
            <p className="bio-text">{profileData.bio}</p>
          )}
        </div>

        <div className="profile-section">
          <h3>Specialties</h3>
          {isEditing ? (
            <div className="specialties-edit">
              {tempData.specialties.map((specialty, index) => (
                <div key={index} className="specialty-input-group">
                  <input 
                    type="text"
                    value={specialty}
                    onChange={(e) => handleSpecialtiesChange(index, e.target.value)}
                    placeholder="Specialty"
                  />
                  <button onClick={() => handleRemoveSpecialty(index)} className="remove-btn">
                    ✕
                  </button>
                </div>
              ))}
              <button onClick={handleAddSpecialty} className="add-specialty-btn">
                + Add Specialty
              </button>
            </div>
          ) : (
            <div className="specialties-list">
              {profileData.specialties.map((specialty, index) => (
                <span key={index} className="specialty-tag">{specialty}</span>
              ))}
            </div>
          )}
        </div>

        <div className="profile-section">
          <h3>Contact Information</h3>
          {isEditing ? (
            <div className="contact-edit">
              <div className="contact-input-group">
                <label>Email:</label>
                <input 
                  type="email"
                  value={tempData.email}
                  onChange={(e) => handleChange('email', e.target.value)}
                  placeholder="Email Address"
                />
              </div>
              <div className="contact-input-group">
                <label>Phone:</label>
                <input 
                  type="tel"
                  value={tempData.phone}
                  onChange={(e) => handleChange('phone', e.target.value)}
                  placeholder="Phone Number"
                />
              </div>
              <div className="contact-input-group">
                <label>Location:</label>
                <input 
                  type="text"
                  value={tempData.location}
                  onChange={(e) => handleChange('location', e.target.value)}
                  placeholder="Location"
                />
              </div>
            </div>
          ) : (
            <div className="contact-info">
              <p><strong>Email:</strong> {profileData.email}</p>
              <p><strong>Phone:</strong> {profileData.phone}</p>
              <p><strong>Location:</strong> {profileData.location}</p>
            </div>
          )}
        </div>

        <div className="profile-section">
          <h3>Certifications & Qualifications</h3>
          {isEditing ? (
            <div className="certifications-edit">
              {tempData.certifications.map((certification, index) => (
                <div key={index} className="certification-input-group">
                  <input 
                    type="text"
                    value={certification}
                    onChange={(e) => handleCertificationChange(index, e.target.value)}
                    placeholder="Certification"
                  />
                  <button onClick={() => handleRemoveCertification(index)} className="remove-btn">
                    ✕
                  </button>
                </div>
              ))}
              <button onClick={handleAddCertification} className="add-certification-btn">
                + Add Certification
              </button>
            </div>
          ) : (
            <ul className="certifications-list">
              {profileData.certifications.map((certification, index) => (
                <li key={index}>{certification}</li>
              ))}
            </ul>
          )}
        </div>
      </div>
  );
};

export default Profile;